<script>
  export default { name: 'NotFound' }
</script>
<template>
  <h2>Cette page n'existe pas</h2>
  <router-link id="vers-accueil" to="/">Revenir à l'accueil</router-link>
</template>

<style lang="css" scoped>
  #vers-accueil {
    padding: 8px;
    background-color: rgb(242, 242, 242);
    border-radius: 4px;
    margin: 32px;
  }
</style>
